import template from './adpButton.html';
import controller from './adpButton.controller';
import './adpButton.less';

let adpButtonComponent = {
  restrict: 'E',
  bindings: {
      label: "@",
      url: "@",
      action: '&',
      isLoading: "<",
      isSuccess: "<",
      isFail: "<"
  },
  template,
  controller
};

export default adpButtonComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpButton/adpButton.component.js